module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/calendar.svg?7d7d17cf";